import { useContext, useEffect, useRef, useState } from 'react'
import { api } from '../../../api/APIMiddlewares'
import { getUsers } from '../../../api/AdminAPI'
import { Button, Center } from '@mantine/core'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { Message, changeTextCapital, checkRole } from '../../../_metronic/helpers/AssetHelpers'
import { sendUpdateAssetEmail } from '../../../api/AssetsAPI'
import { API_BASE_URL, EDIT_ROW_COLORS } from '../../../utils/contants'
import InputErrorBox from '../../components/InputErrorBox'
import Select2 from '../../components/select2'
import ListPagination from '../../components/ListPagination'
import roleContext from '../../context/roleContext'
import { setupAxios, useAuth } from '../../modules/auth'
import { RoleContextValue } from '../../types/OtherTypes'
import {
  cancelFormSubmit,
  cancelSubmit,
  getAsset,
  getAssetById,
  handleFormFieldChange,
  handleFormFieldSubmit,
  handleInputChange,
  handleSubmit,
  validateForm,
  validateFormField,
} from './AssetsFunction'
import AssignAssets from './AssignAssets'
import { getUserAssetById, handleReturnSubmit, validateReturnForm } from './AssignAssetsFunction'
import CommentPopup from './CommentPopup'
import {
  CATEGORY_NAME_REQUIRED_MESSAGE,
  isAssetCategoryNameValidationError,
  validateAssetCategoryName,
} from './assetCategoryValidation'
const toDateInput = (date?: string | null) => {
  if (!date) return ''
  return date.split('T')[0]
}
const getTodayInputDate = () => {
  const today = new Date()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${today.getFullYear()}-${month}-${day}`
}

const Assets = () => {
  // let roleState: RoleContextValue = useContext(roleContext)
  
  // const isAdmin = roleState.roleName?.toLowerCase() === 'admin'
  // const isSuperAdmin = roleState.roleName === 'Super Admin'

  // const canEditAsset =
  //   isAdmin ||
  //   isSuperAdmin ||
  //   checkRole(['asset_management_system_edit'], roleState.features)
  
  let roleState: RoleContextValue = useContext(roleContext)
  const roleName = roleState.roleName?.trim().toLowerCase()
  // Strict role check
  const isAdmin = roleName === 'admin'
  const isSuperAdmin = roleName === 'super admin'
  // ONLY Admin & Super Admin can edit assets
  const canEditAsset = isAdmin || isSuperAdmin

  const [asset, setAsset] = useState([
    {
      id: '',
      createdAt: '',
      updatedAt: '',
      category: '',
      subCategory: '',
      tag: '',
      serialNumber: '',
      description: '',
      purchaseDate: '',
      status: '',
      assignee: '',
      location: '',
      locationType: '',
      UserAssets: [
        {
          issueDate: '',
          returnDate: '',
          user: {
            firstName: '',
            lastName: '',
          },
        },
      ],
    },
  ])

  const [userAsset, setUserAsset] = useState([
    {
      id: '',
      issueDate: '',
      returnDate: '',
      user: {
        id: '',
        firstName: '',
        lastName: '',
      },
      asset: {
        id: '',
        createdAt: '',
        category: '',
        status: '',
        brand: '',
        serialNo: '',
        description: '',
        location: '',
        locationType: '',
      },
    },
  ])
  const formFieldState = {
    id: '',
    issueDate: '',
    user: '',
    location: '',
    locationType: '',
    returnDate: '',
  }



  const [formField, setFormField] = useState(formFieldState)
  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const [APIStatus, setAPIStatus] = useState<any>({})
  const { currentUser } = useAuth()

  const initialState = {
    assetTag: '',
    category: '',
    subCategory: '',
    brand: '',
    serialNo: '',
    description: '',
    purchaseDate: '',
    status: '',
    assignee: '',
    user: '',
    issueDate: '',
    returnDate: '',
    comment: '',
  }
  const [users, setUsers] = useState<
    { id: string; firstName: string; lastName: string, employeeCode?: string }[]
  >([])
  const employeeCodeOptions = Array.isArray(users) ? users.map(u => ({
    value: u.id,                 // userId (important)
    label: u.employeeCode || ''  // employee code shown
  })) : [];

  console.log('USER SELECT DATA:', employeeCodeOptions)

  useEffect(() => {
    console.log('USERS FROM API:', users)
  }, [users])

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await getUsers()
        console.log('USERS FROM API:', res?.data)
        setUsers(Array.isArray(res?.data?.items) ? res.data.items : [])
        //setUsers(res?.data || [])
      } catch (error) {
        console.error('Failed to load users', error)
        setUsers([])
      }
    }

    fetchUsers()
  }, [])

  // const formatDate = (dateStr: string) => {
  //   const [day, month, year] = dateStr.split('-')
  //   return `${year}-${month}-${day}`
  // }

  const [inputField, setInputField] = useState(initialState)
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [returnDateModal, setReturnDateModal] = useState(false)
  const [comment, setComment] = useState('')
  const [commentError, setCommentError] = useState<string | null>(null)
  const [usersOptions, setUsersOptions] = useState<UserOption[]>([])
  const sortedUserNames = usersOptions.slice().sort((a, b) => a.label.localeCompare(b.label))
  const sortedEmployeeNames = usersOptions
    .map((user) => ({
      label: `${user.firstName} ${user.lastName} (${user.label})`,
      value: user.value,
    }))
    .sort((first, second) => first.label.localeCompare(second.label))
  type UserOption = {
    label: string;
    value: string;
    firstName: string;
    lastName: string;
  };

  //Assets Sub Category
  const [showRow, setShowRow] = useState<number[]>([])
  const [subCategories, setSubCategories] = useState<
  { label: string; value: string }[]
  >([])
  const [categories, setCategories] = useState<
    { label: string; value: string }[]
  >([])
  const [categoryRecords, setCategoryRecords] = useState<any[]>([])
  const [
    openSubCategoryModal,
    setOpenSubCategoryModal,
  ] = useState(false)
  const [subCategoryName, setSubCategoryName] = useState("")

  //Assets Category
  const [openCategoryModal, setOpenCategoryModal] = useState(false)
  const [categoryName, setCategoryName] = useState("")
  const [categoryDescription, setCategoryDescription] = useState("")
  const [categoryNameError, setCategoryNameError] = useState<string>()
  const categoryNameInputRef = useRef<HTMLInputElement>(null)

  const fetchCategories = async () => {
    try {
      const { token, tenantId } = setupAxios()
      const response = await api.get(
        `/asset-category/all${canEditAsset ? '?includeInactive=true' : ''}`,
        token,
        tenantId,
        false
      )
      const categoryData = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : []

      const sortedCategories = categoryData
        .filter((category: any) => category?.name)
        .sort((first: any, second: any) => first.name.localeCompare(second.name))
      setCategoryRecords(sortedCategories)
      setCategories(
        sortedCategories
          .filter((category: any) => category.isActive !== false)
          .map((category: any) => ({
            label: category.name,
            value: category.name,
          }))
      )
    } catch (error) {
      console.error('Failed to load asset categories', error)
      setCategories([])
    }
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  const handleAddCategory = async () => {
    const validationError = validateAssetCategoryName(categoryName)
    if (validationError) {
      setCategoryNameError(validationError)
      categoryNameInputRef.current?.focus()
      return
    }

    const trimmedCategoryName = categoryName.trim()
    setCategoryName(trimmedCategoryName)

    try {
      const { token, tenantId } = setupAxios()
      const result = await api.post(
        '/asset-category/create',
        token,
        tenantId,
        {
          body: JSON.stringify({ name: trimmedCategoryName, description: categoryDescription }),
        },
        false
      )
      if (!result?.id && !result?.data?.id) {
        if (isAssetCategoryNameValidationError(result)) {
          setCategoryNameError(CATEGORY_NAME_REQUIRED_MESSAGE)
          categoryNameInputRef.current?.focus()
          return
        }

        const safeMessage =
          result?.statusCode === 403 || result?.message === 'Category already exists'
            ? result.message
            : 'Failed to add category. Please try again.'
        toast.error(safeMessage)
        return
      }

      await fetchCategories()
      toast.success('Category Added')
      setOpenCategoryModal(false)
      setCategoryName('')
      setCategoryDescription('')
      setCategoryNameError(undefined)
    } catch {
      toast.error('Failed to add category. Please try again.')
    }
  }

  const fetchNames = () => {
    const { token, tenantId } = setupAxios()
    axios
      .get(API_BASE_URL + `/activeUsers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {
        let userData: UserOption[] = []
        response.data.data?.forEach((obj: { firstName: string; lastName: string; id: string; employeeCode: string }) => {
          userData.push({
            label: obj.employeeCode,
            // value: obj.employeeCode,
            value: obj.id,
            firstName: obj.firstName,      // ✅ needed for auto-fill
            lastName: obj.lastName,
          })
        })
        setUsersOptions(userData)
      })
      .catch((error) => {
        console.error('Error fetching names:', error)
      })
  }
  const handleAcknowledge = async (userAssetId: string) => {
    try {
      const { token, tenantId } = setupAxios();

      if (!userAssetId) {
        toast.error('Invalid asset assignment');
        return;
      }

      const res = await axios.put(
        `${API_BASE_URL}/assets/userAsset/${userAssetId}/acknowledge`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-Tenant-Id': tenantId,
          },
        }
      );

      if (res.data?.statusCode === 200) {
        toast.success(res.data.message || 'Asset acknowledged');
        fetchAssets();
      } else {
        toast.error(res.data.message || 'Failed to acknowledge asset');
      }
    } catch (error) {
      console.error(error);
      toast.error('Acknowledge failed');
    }
  };


  const [isCommentPopupOpen, setIsCommentPopupOpen] = useState(false)

  const checkArrayElement = (element: number) => {
    let arr: number[] = [...showRow]
    let isExists = false
    for (let i = 0; i <= arr.length - 1; i++) {
      if (arr[i] === element) {
        arr.splice(i, 1)
        isExists = true
        break
      }
    }

    if (!isExists) {
      arr.push(element)
    }
    setShowRow(arr)
  }
  const handleCancelComment = () => {
    setIsCommentPopupOpen(false)
    setComment('')
    setCommentError(null)
    setEditId(null)
  }

  const handleSubmitComment = () => {
    let error = 0
    if (!comment) {
      error = error + 1
      setCommentError('Please enter a valid Justification.')
    } else if (comment.length >= 500) {
      error = error + 1
      setCommentError('Justification must not exceed 500 characters.')
    }

    if (error === 0) {
      setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
      sendUpdateAssetEmail(inputField, editId ?? '', currentUser?.id ?? '', comment).then(
        (res: any) => {
          if (res.statusCode === 200) {
            getAsset(setAsset, setAPIStatus)
            toast.success(res.message)
            setIsAddUserModalOpen(false)
            cancelSubmit(setInputField, initialState, setEditId, setInputError)
            handleCancelComment()
          } else {
            Message(res.message, 'error')
            setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
          }
          setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
          handleCancelComment()
        }
      )
    } else {
      console.error('Email is null. Unable to update status.')
    }
  }

  //Sub Category Assets
  const fetchSubCategories = async (
    categoryName: string
    ) => {
      try {
        const { token, tenantId } = setupAxios()
        const response = await api.get(
          `/asset-sub-category/${encodeURIComponent(categoryName)}`,
          token,
          tenantId,
          false
        )
        const subCategoryData = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : []
        const formattedData =
          subCategoryData.map((item: any) => ({
            label: item.name,
            value: item.name,
          }))
        setSubCategories(formattedData)
      } catch (error) {
        console.log(error)
      }
    }


  const [searchTerm, setSearchTerm] = useState('')
  const [filterCategory, setFilterCategory] = useState('')
  const [filterSubCategory, setFilterSubCategory] = useState('')
  const [filterStatus, setFilterStatus] = useState('')
  const [filterSubCategories, setFilterSubCategories] = useState<
    { label: string; value: string }[]
  >([])
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10, total: 0, totalPages: 0 })
  const [sortBy, setSortBy] = useState('createdAt')
  const [sortOrder, setSortOrder] = useState('desc')
  const fetchAssets = () => {
    getAsset(
      setAsset,
      setAPIStatus,
      {
        search: searchTerm,
        category: filterCategory,
        subCategory: filterSubCategory,
        status: filterStatus,
        page: pagination.page,
        pageSize: pagination.pageSize,
        sortBy,
        sortOrder,
      },
      setPagination
    )
  }
  const resetInputFields = () => {
    setInputField(initialState)
    setEditId(null)
    setInputError({})
  }
  useEffect(() => {
    getAsset(
      setAsset,
      setAPIStatus,
      {
        search: searchTerm,
        category: filterCategory,
        subCategory: filterSubCategory,
        status: filterStatus,
        page: pagination.page,
        pageSize: pagination.pageSize,
        sortBy,
        sortOrder,
      },
      setPagination
    )
  }, [searchTerm, filterCategory, filterSubCategory, filterStatus, pagination.page, pagination.pageSize, sortBy, sortOrder])

  useEffect(() => {
    setIsAddUserModalOpen(false)
    setModalOpen(false)
  }, [])

  useEffect(() => {
    let cancelled = false
    const loadSubcategories = async () => {
      if (!filterCategory) {
        setFilterSubCategories([])
        return
      }
      try {
        const { token, tenantId } = setupAxios()
        const response = await api.get(
          `/asset-sub-category/${encodeURIComponent(filterCategory)}`,
          token,
          tenantId,
          false
        )
        const rows = Array.isArray(response) ? response : response?.data || []
        if (!cancelled) {
          setFilterSubCategories(rows.map((row: any) => ({ label: row.name, value: row.name })))
        }
      } catch (error) {
        if (!cancelled) setFilterSubCategories([])
      }
    }
    loadSubcategories()
    return () => {
      cancelled = true
    }
  }, [filterCategory])

  const handleClose = () => {
    setModalOpen(false)
    setReturnDateModal(false)
    setIsAddUserModalOpen(false)
    setExpandedRows([])
  }

  // State to manage expanded rows
  const [expandedRows, setExpandedRows] = useState<number[]>([]);
  // Function to set expanded rows
  function handleSetExpandedRows(rows: number[]) {
    // Only allow unique row indices
    setShowRow(rows.filter((v, i, a) => a.indexOf(v) === i));
  }
  const [returnDateField, setReturnDateField] = useState({
    returnDate: ''
  })

  const filteredAssets = asset
  const hasActiveFilters = Boolean(
    searchTerm ||
      filterCategory ||
      filterSubCategory ||
      filterStatus ||
      sortBy !== 'createdAt' ||
      sortOrder !== 'desc' ||
      pagination.page !== 1 ||
      pagination.pageSize !== 10
  )
  return (
    <>
      <Modal
        show={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        animation={false}
        backdrop='static'
        centered
      >
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add Asset Details</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleClose()

              setInputError('')
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>

        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Category</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <Select2
              name='category'
              data={categories}
              value={inputField.category}
              onChange={(selectedOption: any) => {
                setInputField((prevInputField) => ({
                  ...prevInputField,
                  category: selectedOption,
                  subCategory: '',
                }))
                setInputError((prev: any) => ({ ...prev, subCategory: undefined }))
                if (selectedOption) fetchSubCategories(selectedOption)
                else setSubCategories([])
              }}
            />
            {<InputErrorBox Message={inputError.category} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'> Sub Category</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            {/* <Select2
              name='category'
              data={[
                { label: 'Laptop', value: 'Laptop' },
                { label: 'Mouse', value: 'Mouse' },
                { label: 'Monitor', value: 'Monitor' },
                { label: 'Keyboard', value: 'Keyboard' },
                { label: 'CPU', value: 'CPU' },
              ].sort((a, b) => a.label.localeCompare(b.label))}
              value={inputField.subCategory}
              onChange={(selectedOption: any) => {
                setInputField((prevInputField) => ({
                  ...prevInputField,
                  subCategory: selectedOption,
                }))
              }}
            /> */}
            <Select2
              name='subCategory'
              data={subCategories}
              value={inputField.subCategory}
              onChange={(selectedOption: any) => {
                setInputField((prevInputField) => ({
                  ...prevInputField,
                  subCategory: selectedOption,
                }))
              }}
            />
            {<InputErrorBox Message={inputError.subCategory} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Asset Tag</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Asset Tag'
              name='brand'
              value={inputField.brand}
              onChange={(event) => handleInputChange(event, setInputField, inputField)}
            />
            {<InputErrorBox Message={inputError.brand} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Serial No.</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Serial No.'
              name='serialNo'
              value={inputField.serialNo}
              onChange={(event) => handleInputChange(event, setInputField, inputField)}
            />
            {<InputErrorBox Message={inputError.serialNo} />}
          </div>

          {/* <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Description</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Description'
              name='description'
              value={inputField.description}
              onChange={(event) => handleInputChange(event, setInputField, inputField)}
            />
            {<InputErrorBox Message={inputError.description} />}
          </div> */}
          <div className='fv-row mb-5 col-md-12'>
  <label className='fs-6 fw-semibold mb-2'>Description</label>
  <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

  <textarea
    className='form-control'
    placeholder='Description'
    name='description'
    rows={4}   // you can adjust height
    value={inputField.description}
    onChange={(event) => handleInputChange(event, setInputField, inputField)}
  />

  {<InputErrorBox Message={inputError.description} />}
</div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Purchase Date</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='date'
              name='purchaseDate'
              max={getTodayInputDate()}
              value={inputField.purchaseDate}
              onChange={(event) => {
                const value = event.target.value
                handleInputChange(event, setInputField, inputField)
                setInputError((prev: any) => ({
                  ...prev,
                  purchaseDate: value > getTodayInputDate()
                    ? 'Purchase Date must not be greater than the current date.'
                    : undefined,
                }))
              }}
            />
            {<InputErrorBox Message={inputError.purchaseDate} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Status</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <Select2
              name='status'
              data={[
                { label: 'Available', value: 'Available' },
                { label: 'UnderMaintenance', value: 'UnderMaintenance' },
                { label: 'Decommissioned', value: 'Decommissioned' },
                { label: 'Assigned', value: 'Assigned' },
              ].sort((a, b) => a.label.localeCompare(b.label))}
              value={inputField.status}
              onChange={(selectedOption: any) => {
                setInputField((prevInputField) => ({
                  ...prevInputField,
                  status: selectedOption,
                }))
              }}

            />

            <InputErrorBox Message={inputError.status} />
          </div>


          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
              }}
              type='button'
              disabled={SubmitAPIStatus?.loading}
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{ marginLeft: '15px' }}
            >
              Clear
            </Button>
            <Button
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              onClick={() => {
                handleSubmit(
                  inputField,
                  // getAsset,
                  setAsset,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  validateForm,
                  setSubmitAPIStatus,
                  setIsAddUserModalOpen,
                  fetchAssets,
                  setIsCommentPopupOpen
                )
              }}
            >
              {editId !== null ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </Modal>
      {/* //end of the form */}
      <Modal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        animation={false}
        backdrop='static'
        centered
      >
        <div className='modal-header'>
          {/* <h2 className='fw-bolder'>{editId ? 'Edit Assignment' : 'Assignee Asset'}</h2> */}
          <h2 className='fw-bolder'>{editId ? 'Assets Assignment' : 'Assignee Asset'}</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleClose()
              setInputError('')
              setEditId(null)
              cancelFormSubmit(setFormField, formFieldState, setEditId, setInputError)
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Employee Code</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>


            {/* <Select2
              //name='username'
              data={sortedUserNames}
              value={formField.user}
              onChange={(selectedOption: string) => {
                setFormField((prevFormField) => ({
                  ...prevFormField,
                  user: selectedOption,
                }))
              }}
            />
             <label className='fs-6 fw-semibold mb-2'>User Name</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <Select
              //label="User Name"
              data={userSelectData}
              value={formField.user}
              onChange={(value) => {
                if (!value) return
                setFormField({ ...formField, user: value })
                
              }}
              searchable
              nothingFound="No users found"
              required
            /> */}

            {/* User Code */}

            <Select2
              data={sortedUserNames}
              value={formField.user}
              clearable
              error={inputError.user ? ' ' : undefined}
              placeholder='Select employee code'
              onChange={(selectedOption: string | null) => {
                setFormField((prevFormField) => ({ ...prevFormField, user: selectedOption || '' }))
                setInputError((prev: any) => ({ ...prev, user: undefined }))
              }}
            />

            {/* Both selectors use the user ID, so duplicate names remain unambiguous. */}
            <label className='fs-6 fw-semibold mb-2'>User Name</label>
            <Select2
              data={sortedEmployeeNames}
              value={formField.user}
              clearable
              error={inputError.user ? ' ' : undefined}
              placeholder='Select employee name'
              onChange={(selectedOption: string | null) => {
                setFormField((prevFormField) => ({ ...prevFormField, user: selectedOption || '' }))
                setInputError((prev: any) => ({ ...prev, user: undefined }))
              }}
            />
            {<InputErrorBox Message={inputError.user} />}
          </div>

          <div className='fv-row mb-5 col-md-12'>
            <label className='required fw-bold fs-6 mb-2'>Onsite/Remote</label>
            <div className='d-flex mt-2'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='radio'
                  id='onsite'
                  name='locationType'
                  value='onsite'
                  checked={formField.locationType === 'onsite'}
                  onChange={(event) => {
                    handleFormFieldChange(event, setFormField, formField)
                  }}
                />
                <label htmlFor='onsite' className='fw-bold text-gray-800 d-block me-3'>
                  Onsite
                </label>
              </div>

              <div className='form-check' style={{ paddingRight: '20px' }}>
                <input
                  className='form-check-input'
                  type='radio'
                  name='locationType'
                  placeholder='radio1'
                  value='remote'
                  id='remote'
                  checked={formField.locationType === 'remote'}
                  onChange={(event) => {
                    handleFormFieldChange(event, setFormField, formField)
                  }}
                />

                <label htmlFor='remote' className=' fw-bold text-gray-800 d-block'>
                  Remote
                </label>
              </div>
            </div>
            <InputErrorBox Message={inputError.locationType} />
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Location</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Location'
              name='location'
              value={formField.location}
              onChange={(event) => handleFormFieldChange(event, setFormField, formField)}
            />
            {<InputErrorBox Message={inputError.location} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Issue Date</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='date'
              name='issueDate'
              max={getTodayInputDate()}
              value={formField.issueDate}
              onChange={(event) => {
                const value = event.target.value
                handleFormFieldChange(event, setFormField, formField)
                setInputError((prev: any) => ({
                  ...prev,
                  issueDate: value > getTodayInputDate()
                    ? 'Issue Date must not be greater than the current date.'
                    : undefined,
                }))
              }}
            />
            {<InputErrorBox Message={inputError.issueDate} />}
          </div>
          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelFormSubmit(setFormField, formFieldState, setEditId, setInputError)
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{ marginLeft: '15px' }}
            >
              Clear
            </Button>
            <Button
              loaderPosition='center'
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              disabled={SubmitAPIStatus.loading}
              onClick={() => {
                if (SubmitAPIStatus.loading) return;   //  Stop to double click
                // setSubmitAPIStatus({ loading: true }); // disable immediately
                handleFormFieldSubmit(
                  formField,
                  // getAsset,
                  setAsset,
                  setEditId,
                  formFieldState,
                  setFormField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  validateFormField,
                  setSubmitAPIStatus,
                  setModalOpen,
                  fetchAssets,
                  setUserAsset
                )
              }}
            >
              Assign
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        show={returnDateModal}
        onClose={() => setReturnDateModal(false)}
        animation={false}
        backdrop='static'
        centered
      >
        {/* begin::modal header--add holiday */}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Return Asset</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleClose()
              setInputError('')
              setEditId(null)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Return Date</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='date'
              name="returnDate"
              max={getTodayInputDate()}
              value={returnDateField.returnDate || ''}
              onChange={(e) => {
                const value = e.target.value
                setReturnDateField({ returnDate: value })
                setInputError((prev: any) => ({
                  ...prev,
                  returnDate: value > getTodayInputDate()
                    ? 'Return Date must not be later than the current date.'
                    : undefined,
                }))
              }}
            />
            {inputError?.returnDate && (
              <small className="text-danger">{inputError.returnDate}</small>
            )}
          </div>

          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{ marginLeft: '15px' }}
            >
              Clear
            </Button>
            <Button
              loaderPosition='center'
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              onClick={() => {
                if (!SubmitAPIStatus.loading) {
                  handleReturnSubmit(
                    {
                      category: inputField.category,      // from main asset
                      brand: inputField.brand,
                      serialNo: inputField.serialNo,
                      user: formField.user,               // assigned user
                      issueDate: formField.issueDate,          //  FIXED
                      returnDate: returnDateField.returnDate,  //  FIXED
                    },
                    setUserAsset,
                    setEditId,
                    initialState,
                    setInputField,
                    editId,
                    cancelSubmit,
                    setAPIStatus,
                    setInputError,
                    validateReturnForm,
                    setSubmitAPIStatus,
                    fetchAssets,
                    () => setReturnDateModal(false)

                  )
                }
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>

      {/* Assets Category Added */}
      <Modal
        show={openCategoryModal}
        onHide={() =>
          setOpenCategoryModal(false)
        }
        centered
      >
      <div className='modal-header'>
        <h2>Add Category</h2>
        <button
          className='btn btn-sm btn-danger'
          onClick={() =>
            setOpenCategoryModal(false)
          }
        >
          X
        </button>
      </div>
      <div className='m-3'>
        <div className='mb-3'>
          <label>Category Name</label>
          <input
            ref={categoryNameInputRef}
            className={`form-control ${categoryNameError ? 'is-invalid' : ''}`}
            type='text'
            value={categoryName}
            aria-invalid={Boolean(categoryNameError)}
            aria-describedby={categoryNameError ? 'asset-category-name-error' : undefined}
            onChange={(e) => {
              setCategoryName(e.target.value)
              setCategoryNameError(undefined)
            }}
            placeholder="Enter category name"
          />
          {categoryNameError && (
            <div id='asset-category-name-error'>
              <InputErrorBox Message={categoryNameError} />
            </div>
          )}
        </div>
        <div className='mb-3'>
          <label>Description</label>
          <textarea
            className='form-control'
            value={categoryDescription}
            onChange={(e) => setCategoryDescription(e.target.value)}
            maxLength={500}
            placeholder='Optional description'
            rows={3}
          />
        </div>
        <div className='mb-3'>
          <label className='d-block mb-2'>Categories</label>
          {categoryRecords.map((category) => (
            <div className='d-flex align-items-center justify-content-between border-bottom py-2' key={category.id}>
              <div>
                <div>{category.name}</div>
                {category.description && <small className='text-muted'>{category.description}</small>}
              </div>
              <button
                type='button'
                className={`btn btn-sm ${category.isActive ? 'btn-light-danger' : 'btn-light-success'}`}
                disabled={category.name.trim().toLowerCase() === 'it assets'}
                onClick={async () => {
                  try {
                    const { token, tenantId } = setupAxios()
                    const result = await api.put(
                      `/asset-category/${category.id}`,
                      token,
                      tenantId,
                      { body: JSON.stringify({ isActive: !category.isActive }) },
                      false
                    )
                    if (!result?.id && !result?.data?.id) {
                      throw new Error(result?.message || 'Category update failed')
                    }
                    await fetchCategories()
                  } catch (error) {
                    toast.error('Failed to update category status')
                  }
                }}
              >
                {category.isActive ? 'Deactivate' : 'Activate'}
              </button>
            </div>
          ))}
        </div>

        <div className='d-flex justify-content-end'>
          <button
            className='btn btn-primary'
            type='button'
            onClick={handleAddCategory}
          >
            Add Category
          </button>
        </div>
      </div>
      </Modal>

      {/* Assets Sub Category Added */}
      <Modal
        show={openSubCategoryModal}
        onHide={() =>
          setOpenSubCategoryModal(false)
        }
        centered
      >
      <div className='modal-header'>
        <h2>Manage Sub Category</h2>
        <button
          className='btn btn-sm btn-danger'
          onClick={() =>
            setOpenSubCategoryModal(false)
          }
        >
          X
        </button>
      </div>
      <div className='m-3'>
        <div className='mb-3'>
          <label>Category</label>
          <span className='text-danger ms-1'>*</span>
          <Select2
            data={categories}
            value={inputField.category}
            onChange={(selected: any) => {
              setInputField((prev) => ({
                ...prev,
                category: selected,
                subCategory: '',
              }))
              setInputError((prev: any) => ({ ...prev, category: undefined }))
              if (selected) fetchSubCategories(selected)
              else setSubCategories([])
            }}
          />
          <InputErrorBox Message={inputError.category} />
        </div>
        <div className='mb-3'>
          <label>Sub Category</label>
          <span className='text-danger ms-1'>*</span>
          <input
            className='form-control'
            type='text'
            value={subCategoryName}
            onChange={(e) => {
              setSubCategoryName(e.target.value)
              setInputError((prev: any) => ({ ...prev, subCategory: undefined }))
            }}
          />
          <InputErrorBox Message={inputError.subCategory} />
        </div>

        <div className='d-flex justify-content-end'>
          <button
            className='btn btn-primary'
            onClick={async () => {
              try {
                if (!inputField.category) {
                  setInputError((prev: any) => ({
                    ...prev,
                    category: 'Please select a Category.',
                  }))
                  return
                }
                if (!subCategoryName.trim()) {
                  setInputError((prev: any) => ({
                    ...prev,
                    subCategory: 'Please enter a Sub Category.',
                  }))
                  return
                }
                const { token, tenantId } = setupAxios()
                const result = await api.post(
                  '/asset-sub-category/create',
                  token,
                  tenantId,
                  {
                    body: JSON.stringify({ category: inputField.category, name: subCategoryName }),
                  },
                  false
                )
                if (!result?.id && !result?.data?.id) {
                  throw new Error(result?.message || 'Subcategory was not saved')
                }
                toast.success(
                  'Sub Category Added'
                )
                setOpenSubCategoryModal(
                  false
                )
                fetchSubCategories(
                  inputField.category
                )
                setSubCategoryName("")
              } catch (error) {
                toast.error((error as Error)?.message || 'Failed to add Sub Category')
              }
            }}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
              <div className='card-title'>Asset Details</div>
              <div
                className='d-flex mt-4 justify-content-end'
                data-kt-user-table-toolbar='base'
                style={{ height: '3rem' }}
              >
                {/* Begin::Add User button */}

                {/* <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={() => {
                    setExpandedRows([])
                    setIsAddUserModalOpen(true)
                    resetInputFields()
                  }}
                  // hidden={!checkRole(['asset_management_system_edit'], roleState.features)}
                  hidden={!canEditAsset}
                >
                  Add Asset
                </button> */}
                <div className='d-flex gap-2'>
                  <button
                    type='button'
                    className='btn btn-sm btn-info'
                    onClick={() =>
                      setOpenCategoryModal(true)
                    }
                    hidden={!canEditAsset}
                  >
                    Add Category
                  </button>
                  <button
                    type='button'
                    className='btn btn-sm btn-success'
                    onClick={() =>
                      setOpenSubCategoryModal(true)
                    }
                    hidden={!canEditAsset}
                  >
                    Manage Sub Category
                  </button>
                  <button
                    type='button'
                    className='btn btn-sm btn-primary'
                    onClick={() => {
                      setExpandedRows([])
                      setIsAddUserModalOpen(true)
                      resetInputFields()
                    }}
                    hidden={!canEditAsset}
                  >
                    Add Asset
                  </button>
                </div>
                {/* <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleAcknowledge}
                >
                  <i className="fas fa-check me-1"></i>
                  Acknowledge
                </button> */}

                {/* end::Add user button */}
              </div>

            </div>
            {/* begin:: card body */}
            <div className='card-body'>
              <div className='d-flex flex-nowrap align-items-end gap-3 mb-4 overflow-auto pb-2'>
                <div style={{ flex: '1.5 1 240px', minWidth: '240px' }}>
                  <label className='form-label'>Search</label>
                  <div className='input-group'>
                    <span className='input-group-text'>
                      <i className='fa fa-search text-muted'></i>
                    </span>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Asset tag or serial number'
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value)
                        setPagination((previous) => ({ ...previous, page: 1 }))
                      }}
                    />
                    {searchTerm && (
                      <button className='btn btn-light' type='button' title='Clear search' onClick={() => {
                        setSearchTerm('')
                        setPagination((previous) => ({ ...previous, page: 1 }))
                      }}>
                        <i className='fa fa-xmark' />
                      </button>
                    )}
                  </div>
                </div>
                <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
                  <label className='form-label'>Category</label>
                  <Select2
                    data={categories}
                    value={filterCategory}
                    clearable
                    onChange={(value: string | null) => {
                      setFilterCategory(value || '')
                      setFilterSubCategory('')
                      setPagination((previous) => ({ ...previous, page: 1 }))
                    }}
                  />
                </div>
                <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
                  <label className='form-label'>Subcategory</label>
                  <Select2
                    data={filterSubCategories}
                    value={filterSubCategory}
                    clearable
                    disabled={!filterCategory}
                    onChange={(value: string | null) => {
                      setFilterSubCategory(value || '')
                      setPagination((previous) => ({ ...previous, page: 1 }))
                    }}
                  />
                </div>
                <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
                  <label className='form-label'>Status</label>
                  <Select2
                    data={[
                      { label: 'Available', value: 'Available' },
                      { label: 'Assigned', value: 'Assigned' },
                      { label: 'Under Maintenance', value: 'UnderMaintenance' },
                      { label: 'Decommissioned', value: 'Decommissioned' },
                      { label: 'Retired', value: 'Retired' },
                      { label: 'Lost', value: 'Lost' },
                      { label: 'Damaged', value: 'Damaged' },
                    ]}
                    value={filterStatus}
                    clearable
                    onChange={(value: string | null) => {
                      setFilterStatus(value || '')
                      setPagination((previous) => ({ ...previous, page: 1 }))
                    }}
                  />
                </div>
                <div style={{ flex: '1 1 170px', minWidth: '170px' }}>
                  <label className='form-label'>Sort by</label>
                  <Select2
                    data={[
                      { label: 'Newest', value: 'createdAt' },
                      { label: 'Category', value: 'category' },
                      { label: 'Subcategory', value: 'subCategory' },
                      { label: 'Asset tag', value: 'brand' },
                      { label: 'Serial number', value: 'serialNo' },
                      { label: 'Purchase date', value: 'purchaseDate' },
                      { label: 'Status', value: 'status' },
                    ]}
                    value={sortBy}
                    onChange={(value: string | null) => {
                      setSortBy(value || 'createdAt')
                      setPagination((previous) => ({ ...previous, page: 1 }))
                    }}
                  />
                </div>
                <div style={{ flex: '0 0 140px', minWidth: '140px' }}>
                  <label className='form-label d-block'>Order</label>
                  <button
                    type='button'
                    className='btn btn-primary w-100 text-nowrap'
                    title={sortOrder === 'desc' ? 'Newest / descending first' : 'Oldest / ascending first'}
                    onClick={() => {
                      setSortOrder((previous) => previous === 'desc' ? 'asc' : 'desc')
                      setPagination((previous) => ({ ...previous, page: 1 }))
                    }}
                  >{sortOrder === 'desc' ? 'Descending' : 'Ascending'}</button>
                </div>
                <div className='d-flex align-items-end' style={{ flex: '0 0 auto' }}>
                  <button
                    type='button'
                    className={`btn ${hasActiveFilters ? 'btn-outline-primary' : 'btn-outline-secondary'} text-nowrap`}
                    disabled={!hasActiveFilters}
                    onClick={() => {
                      setSearchTerm('')
                      setFilterCategory('')
                      setFilterSubCategory('')
                      setFilterStatus('')
                      setSortBy('createdAt')
                      setSortOrder('desc')
                      setPagination({ page: 1, pageSize: 10, total: pagination.total, totalPages: pagination.totalPages })
                    }}
                  >
                    Clear All
                  </button>
                </div>
              </div>
              <div className='table-responsive  '>
                <table
                  className='table 
                    table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                >
                  <thead>
                    <tr>
                      <th className='pl-1 text-center text-muted' style={{ minWidth: '50px' }}>
                        {changeTextCapital('Sr.No')}
                      </th>

                      <th className='pl-1 text-center text-muted' style={{ minWidth: '80px' }}>
                        {changeTextCapital('Asset Tag')}
                      </th>
                      <th className='pl-1 text-center text-muted' style={{ minWidth: '150px' }}>
                        {changeTextCapital('Serial No')}
                      </th>
                      <th className='pl-1 text-center text-muted' style={{ minWidth: '150px' }}>
                        {changeTextCapital('Location')}
                      </th>

                      <th className='pl-1 text-center text-muted' style={{ minWidth: '80px' }}>
                        {changeTextCapital('Status')}
                      </th>

                      <th className='pl-1 text-center text-muted' style={{ minWidth: '100px' }}>
                        {changeTextCapital('Assigned')}
                      </th>

                      <th
                        className='pl-1 text-center text-muted'
                        // hidden={!checkRole(['asset_management_system_edit'], roleState.features)}
                        hidden={!canEditAsset}
                        style={{ minWidth: '80px' }}
                      >
                        {changeTextCapital('Action')}
                      </th>
                      <th className='pl-1 text-center text-muted' style={{ minWidth: '100px' }}>
                        Acknowledge
                      </th>

                    </tr>
                  </thead>
                  {/* {asset?.length > 0 ? ( */}
                  {filteredAssets?.length > 0 ? (
                    <tbody>
                      {/* {asset?.map((obj: any, index: number) => ( */}
                      {filteredAssets?.map((obj: any, index: number) => (
                        <>
                          <tr
                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                            key={obj?.id ?? '-'}
                          >
                            <td className='text-center'>
                              <td>
                                <div className='text-center'>
                                  <i
                                    className={`fas fa-chevron-${showRow.includes(index) ? 'up' : 'down'
                                      }`}
                                    style={{
                                      marginLeft: '2rem',
                                      marginRight: '3px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      checkArrayElement(index)
                                    }}
                                  />
                                  <span> {'   '}</span>
                                  {obj.index || index + 1}
                                </div>
                              </td>
                            </td>
                            <td className='text-center'>
                              {obj?.category && obj?.brand
                                ? `${obj.category} - ${obj.brand}`
                                : obj?.category || obj?.brand || '-'}
                            </td>
                            <td
                              className='text-center'
                              style={{
                                maxWidth: '200px',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                              }}
                            >
                              {obj?.serialNo ?? '-'}
                            </td>
                            <td
                              className='text-center'
                              style={{
                                maxWidth: '300px',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                              }}
                            >
                              {obj?.userAssets?.[0]?.locationType && obj?.userAssets?.[0]?.location
                                ? `${obj.userAssets[0].locationType.charAt(0).toUpperCase() + obj.userAssets[0].locationType.slice(1)} - ${obj.userAssets[0].location}`
                                : obj?.userAssets?.[0]?.location || '-'}
                            </td>
                            <td className='text-center'>
                              {obj?.status ? (
                                <span
                                  className={`badge border background ${obj.status === 'Admin'
                                    ? 'border-success text-success'
                                    : 'border-primary text-primary'
                                    } d-inline-block`}
                                >
                                  {obj.status}
                                </span>
                              ) : (
                                '-'
                              )}
                            </td>

                            <td className='text-center'>
                              {obj?.userAssets && obj?.userAssets.length > 0
                                ? obj?.userAssets?.map(
                                  (asset: any) =>
                                    `${asset?.user?.employeeCode ?? '-'}`
                                )
                                : '-'}
                            </td>

                            <td
                              // hidden={
                              //   !checkRole(['asset_management_system_edit'], roleState.features)
                              // }
                              hidden={!canEditAsset}
                            >
                              {obj?.userAssets?.[0] && obj?.status === 'Assigned' ? (
                                <td>
                                  <div className='text-center'>
                                    <button
                                      className='btn btn-icon btn-light-primary btn-sm me-1'
                                      onClick={() => {
                                        const userAsset = obj?.userAssets?.[0]
                                        if (!userAsset) return

                                        setEditId(userAsset.id) // ✅ USER ASSET ID

                                        setReturnDateField({
                                          returnDate: userAsset.returnDate
                                            ? toDateInput(userAsset.returnDate)
                                            : '',
                                        })

                                        setReturnDateModal(true) // ✅ OPEN RETURN DATE POPUP FIRST
                                      }}

                                      // hidden={
                                      //   !checkRole(
                                      //     ['asset_management_system_edit'],
                                      //     roleState.features
                                      //   )
                                      // }
                                      hidden={!canEditAsset}
                                    >
                                      <i className='far fa-edit'></i>
                                    </button>
                                  </div>
                                </td>
                              ) : (
                                <td>
                                  <div className='d-flex justify-content-center flex-shrink-0'>
                                    {/* <button
                                      className='btn btn-icon btn-light-primary btn-sm me-1'
                                      onClick={() => {
                                        getAssetById(
                                          obj.id,
                                          inputField,
                                          setInputField,
                                          setEditId,
                                          setInputError
                                        )
                                        setEditId(obj.id)
                                        setIsAddUserModalOpen(true)
                                        setFormField(formFieldState)
                                      }}
                                      hidden={
                                        !checkRole(
                                          ['asset_management_system_edit'],
                                          roleState.features
                                        )||
                                        obj.status === 'Decommissioned'

                                      }
                                    >
                                      <i className='far fa-edit'></i>
                                    </button> */}
                                    <button
                                      className='btn btn-icon btn-light-primary btn-sm me-1'
                                      // hidden={
                                      //   !checkRole(['asset_management_system_edit'], roleState.features)
                                      //   obj.status === 'Under Maintenance' ||
                                      //   obj.status === 'Decommissioned'
                                      // }

                                      onClick={() => {
                                        const userAsset = obj?.userAssets?.[0]

                                        if (userAsset) {
                                          // 🔹 Asset is assigned (acknowledged or not) → show Return Date modal
                                          setEditId(userAsset.id) // USER_ASSET ID
                                          setReturnDateField({
                                            returnDate: userAsset.returnDate
                                              ? toDateInput(userAsset.returnDate)
                                              : '',
                                          })
                                          setReturnDateModal(true)
                                        } else {
                                          // 🔹 Asset not assigned → show Asset Details / Add modal
                                          getAssetById(
                                            obj.id,
                                            inputField,
                                            setInputField,
                                            setEditId,
                                            setInputError
                                          )
                                          setEditId(obj.id) // ASSET ID
                                          setIsAddUserModalOpen(true)
                                          setFormField(formFieldState)
                                        }
                                      }}
                                      hidden={
                                        // !checkRole(['asset_management_system_edit'], roleState.features) ||
                                        !canEditAsset ||
                                        obj.status === 'Decommissioned'
                                        // obj.status === 'UnderMaintenance' ||
                                        // obj.status === 'Decommissioned' ||
                                        // (editId === obj.id &&
                                        // (inputField.status === 'UnderMaintenance' || inputField.status === 'Decommissioned'))
                                      }
                                    >
                                      <i className='far fa-edit'></i>
                                    </button>

                                    {/* <button
                                      className="btn btn-icon btn-light-primary btn-sm me-1"
                                      hidden={!checkRole(['asset_management_system_edit'], roleState.features)}
                                      onClick={() => {
                                        const userAsset = obj.userAssets?.[0];

                                        if (!userAsset) {
                                          console.error('No assignment found');
                                          return;
                                        }

                                        setEditId(userAsset.id); // ✅ USER_ASSET_ID

                                        setFormField({
                                          ...formFieldState,
                                          user: userAsset.user?.employeeCode || '',
                                          issueDate: userAsset.issueDate,
                                          location: userAsset.location || '',
                                          locationType: userAsset.locationType || '',
                                        });

                                        setModalOpen(true);
                                      }}
                                    >
                                      <i className="far fa-edit"></i>
                                    </button> */}

                                    {/* <button
  className='btn btn-icon btn-light-primary btn-sm me-1'
  onClick={() => {
    console.log('ROW DATA:', obj);

    // 🔹 CASE 1: ASSIGN (Asset is Available)
    if (obj.status === 'Available') {
      //setEditId(null); // ✅ NO userAssetId
      setFormField(formFieldState); // empty assign form
      setModalOpen(true);
      fetchNames();
      return;
    }

    // 🔹 CASE 2: EDIT ASSIGNMENT (Already Assigned)
    const userAssetId = obj.UserAssets?.[0]?.id;

    if (!userAssetId) {
      console.error('UserAsset ID missing');
      return;
    }

    setEditId(userAssetId);

    getAssetById(
      obj.id,
      inputField,
      setInputField,
      () => {}, // ❌ do not touch editId
      setInputError
    );

    setModalOpen(true);
    fetchNames();
  }}
  hidden={
    !checkRole(
      ['asset_management_system_edit'],
      roleState.features
    )
  }
>
  <i className='fa-solid fa-user-plus'></i>
</button> */}
                                    {/* ASSIGN USER */}
                                    {/* {(!obj?.userAssets || obj.userAssets.length === 0) && (
            <button
              className='btn btn-icon btn-light-primary btn-sm me-1'
              // onClick={() => {
              //   getAssetById(
              //     obj.id,
              //     inputField,
              //     setInputField,
              //     setEditId,
              //     setInputError
              //   );
              //   setEditId(obj.id);
              //   setModalOpen(true);
              //   fetchNames();
              // }}
              title="Assign User"
            onClick={() => {
              setEditId(obj.id); // ✅ ASSET ID
              setFormField(formFieldState); // reset form
              setModalOpen(true);
              fetchNames();
            }}
            >
              <i className='fa-solid fa-user-plus'></i>
            </button>
)} */}{/* ASSIGN USER */}
                                    {/* {(!obj?.UserAssets || obj.UserAssets.length === 0) && (
  <button
    className='btn btn-icon btn-light-primary btn-sm me-1'
    title="Assign User"
    onClick={() => {
      setEditId(obj.id);          // ✅ ASSET ID
      setFormField(formFieldState); // reset form
      setModalOpen(true);
      fetchNames();
    }}
  >
    <i className='fa-solid fa-user-plus'></i>
  </button>
)} */}

                                    {/* Assign User button - show always for admins */}
                                    {/* {checkRole(['asset_management_system_edit'], roleState.features) && (
      <button
        className='btn btn-icon btn-light-primary btn-sm me-1'
        onClick={() => {
          setEditId(obj.id); // set asset ID
          setFormField(formFieldState); // reset form
          setModalOpen(true);
          fetchNames(); // fetch users for dropdown
        }}
      >
        <i className='fa-solid fa-user-plus'></i>
      </button>
    )} */}
                                    {/* <button
  className="btn btn-icon btn-light-primary btn-sm me-1"
  onClick={() => {
    // ASSIGNED → EDIT
    if (obj.status === 'Assigned' && obj.userAssets?.length) {
      setEditId(obj.userAssets[0].id); // ✅ userAssetId
    } 
    // AVAILABLE → ASSIGN
    else {
      setEditId(obj.id); // ✅ assetId
    }

    setFormField(formFieldState);
    setModalOpen(true);
    fetchNames();
  }}
>
  <i className="fa-solid fa-user-plus"></i>
</button> */}
                                    {/* <button
                                      className="btn btn-icon btn-light-primary btn-sm me-1"
                                      hidden={!checkRole(['asset_management_system_edit'], roleState.features)}
                                      onClick={() => {

                                        // 🔹 CASE 1: ASSET ALREADY ASSIGNED → EDIT USER_ASSET
                                        if (obj.status === 'Assigned' && obj.userAssets?.length > 0) {
                                          const userAsset = obj.userAssets[0];

                                          setEditId(userAsset.id); // ✅ USER_ASSET_ID

                                          setFormField({
                                            ...formFieldState,
                                            user: userAsset.user?.id || '',
                                            issueDate: userAsset.issueDate,
                                            location: userAsset.location || '',
                                            locationType: userAsset.locationType || '',
                                            returnDate: userAsset.returnDate
                                              ? userAsset.returnDate
                                              : '',
                                          });

                                          setModalOpen(true);
                                          return;
                                        }

                                        // 🔹 CASE 2: ASSET AVAILABLE → ASSIGN
                                        setEditId(obj.id); // ✅ ASSET_ID
                                        setFormField(formFieldState); // reset form
                                        setModalOpen(true);
                                        fetchNames();
                                      }}
                                    >
                                      <i className="fa-solid fa-user-plus"></i>
                                    </button> */}
                                    {obj?.status === 'Available' && (
                                      <button
                                        className="btn btn-icon btn-light-primary btn-sm me-1"
                                        //hidden={!checkRole(['asset_management_system_edit'], roleState.features)}
                                        hidden={!canEditAsset}
                                        onClick={() => {
                                          setEditId(obj.id);              // ✅ ASSET_ID
                                          setFormField(formFieldState);   // reset
                                          setModalOpen(true);
                                          fetchNames();
                                        }}
                                      >
                                        <i className="fa-solid fa-user-plus"></i>
                                      </button>
                                    )}


                                  </div>
                                </td>


                              )}
                            </td>
                            <td className="text-center">
                              {/* SHOW ACKNOWLEDGE BUTTON */}
                              {!obj?.userAssets?.[0]?.returnDate &&
                                !obj?.userAssets?.[0]?.acknowledged && (
                                  <button
                                    className="btn btn-sm btn-light-success"
                                    title="Acknowledge Asset"
                                    onClick={() =>
                                      //handleAcknowledge(obj.userAssets[0].id)
                                      obj?.userAssets?.[0]?.id && handleAcknowledge(obj.userAssets[0].id)
                                    }
                                  >
                                    <i className="fas fa-check"></i>
                                  </button>
                                )}

                              {/* SHOW ACKNOWLEDGED BADGE */}
                              {obj?.userAssets?.[0]?.acknowledged && (
                                <span className="badge badge-light-success">
                                  Acknowledged
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr key={`secondIndex${index}`} hidden={!showRow.includes(index)}>
                            <td
                              className=' align-middle'
                              colSpan={8}
                              style={{ paddingLeft: '3.5rem', paddingRight: '3.5rem' }}
                            >
                              <>
                                <div className='table-responsive-sm'>
                                  <table className='table table-bordered '>
                                    <thead className='border text-center '>
                                      <tr className='align-middle'>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ width: '200px', whiteSpace: 'pre-wrap' }}
                                        >
                                          {changeTextCapital('Category')}
                                        </th>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ minWidth: '100px' }}
                                        >
                                          {changeTextCapital('Sub Category')}
                                        </th>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ minWidth: '100px' }}
                                        >
                                          {changeTextCapital('Brand Name')}
                                        </th>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ width: '200px', whiteSpace: 'pre-wrap' }}
                                        >
                                          {changeTextCapital('Description')}
                                        </th>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ minWidth: '100px' }}
                                        >
                                          {changeTextCapital('Purchase Date')}
                                        </th>
                                        <th
                                          className='pl-1 text-center text-muted'
                                          style={{ minWidth: '100px' }}
                                        >
                                          {changeTextCapital('Status')}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className='border'>
                                      {asset
                                        ?.filter((detail) => detail.id === obj.id)
                                        ?.map((detail, detailIndex) => (
                                          <tr
                                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''
                                              }`}
                                            key={`${obj?.id ?? '-'}-details`}
                                          >
                                            <td className='p-3 text-center align-middle'>
                                              {obj?.category ?? '-'}
                                            </td>
                                            <td className='p-3 text-center align-middle'>
                                              {obj?.subCategory ?? '-'}
                                            </td>
                                            <td className='p-3 text-center align-middle'>
                                              {obj?.brand ?? '-'}
                                            </td>
                                            {/* <td className='p-3 text-center align-middle'>
                                              {obj?.description ?? '-'}
                                            </td> */}
                                            <td
                                              className='p-3 text-center align-middle'
                                              style={{
                                                whiteSpace: 'pre-line',
                                                wordBreak: 'break-word',
                                              }}
                                            >
                                              {obj?.description ?? '-'}
                                            </td>
                                            {/* <td className='p-3 text-center align-middle'>
                                              {obj?.purchaseDate ?? '-'}
                                            </td> */}
                                            {/* Date Formate YYYY-MM-DD*/}
                                            {/* <td className='p-3 text-center align-middle'>
                                              {obj?.purchaseDate
                                                ? new Date(obj.purchaseDate).toISOString().split('T')[0]
                                                : '-'}
                                            </td> */}
                                            {/* Date Formate DD-MM-YYYY */}
                                            <td className='p-3 text-center align-middle'>
                                              {obj?.purchaseDate
                                                ? new Date(obj.purchaseDate)
                                                    .toLocaleDateString('en-GB')
                                                    .replace(/\//g, '-')
                                                : '-'}
                                            </td>
                                            
                                            <td className='p-3 text-center align-middle'>
                                              {obj?.status ?? '-'}
                                            </td>

                                            {/* Status Column */}
                                            {/* <td className="p-3 text-center align-middle">
                                            {obj?.status ? (
                                              <span
                                                className={`badge ${
                                                  obj.status === "Available"
                                                    ? "bg-success"
                                                    : obj.status === "Assigned"
                                                    ? "bg-primary"
                                                    : obj.status === "Under Maintenance"
                                                    ? "bg-warning text-dark"
                                                    : obj.status === "Decommissioned"
                                                    ? "bg-danger"
                                                    : "bg-secondary"
                                                }`}
                                              >
                                                {obj.status}
                                              </span>
                                            ) : (
                                              "-"
                                            )}
                                          </td> */}




                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={9}>
                          <Center>No Record Available.</Center>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
              <ListPagination
                className='mt-4'
                page={pagination.page}
                pageSize={pagination.pageSize}
                totalRecords={pagination.total}
                disabled={APIStatus.loading}
                onPageChange={(page) => setPagination((previous) => ({ ...previous, page }))}
                onPageSizeChange={(pageSize) => setPagination((previous) => ({ ...previous, page: 1, pageSize }))}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div hidden={!checkRole(['asset_management_system_edit'], roleState.features)}> */}
      <div hidden={!canEditAsset}>
        <AssignAssets
          userAsset={userAsset}
          isModalOpen={modalOpen || isAddUserModalOpen ? true : false}
          setUserAsset={setUserAsset}
          fetchAssets={fetchAssets}
        />
      </div>
      <div>
        <CommentPopup
          isOpen={isCommentPopupOpen}
          comment={comment}
          setComment={setComment}
          setCommentError={setCommentError}
          commentError={commentError}
          onClose={handleCancelComment}
          onSubmit={handleSubmitComment}
        />
      </div>
    </>
  )
}

export default Assets

